import { useEffect, useState } from "react";
import { http, fmtErr } from "@/lib/api";
import { toast } from "sonner";

export default function IDRequirementSettings() {
  const [mode, setMode] = useState("PRIMARY_ONLY");
  const [loaded, setLoaded] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    http.get("/admin/settings/id-requirement").then((r) => { setMode(r.data.mode); setLoaded(true); }).catch(() => {});
  }, []);

  const save = async () => {
    setBusy(true);
    try {
      await http.put("/admin/settings/id-requirement", { mode });
      toast.success("ID requirement saved");
    } catch (e) { toast.error(fmtErr(e)); } finally { setBusy(false); }
  };

  return (
    <div className="card" data-testid="id-requirement-settings">
      <h3 className="font-serif text-2xl mb-3">Guest ID Requirement</h3>
      <p className="text-xs mb-4" style={{ color: "var(--muted)" }}>
        A government-issued photo ID is always mandatory at self check-in. Choose whose IDs are required. Applies to new check-ins immediately.
      </p>
      <label className="flex items-start gap-3 mb-2 text-sm cursor-pointer">
        <input type="radio" name="idreq" style={{ width: "auto" }} data-testid="idreq-primary"
          checked={mode === "PRIMARY_ONLY"} onChange={() => setMode("PRIMARY_ONLY")} />
        Primary Guest Only (booking holder)
      </label>
      <label className="flex items-start gap-3 mb-4 text-sm cursor-pointer">
        <input type="radio" name="idreq" style={{ width: "auto" }} data-testid="idreq-every-adult"
          checked={mode === "EVERY_ADULT"} onChange={() => setMode("EVERY_ADULT")} />
        Every Adult Guest
      </label>
      <button data-testid="idreq-save" onClick={save} disabled={!loaded || busy} className="btn-primary">{busy ? "Saving…" : "Save"}</button>
    </div>
  );
}
